var SKIP = ['nav', 'footer', '.hero', 'script', 'style', 'head'];

// Returns true if el is inside a skipped ancestor
function inSkip(el) {
  return SKIP.some(function (s) { return el.closest(s); });
}

// Apply animation class + stagger delay to a list of elements
function animate(els, cls, stagger) {
  els.forEach(function (el, i) {
    if (inSkip(el) || el.classList.contains('reveal') ||
        el.classList.contains('reveal-left') || el.classList.contains('reveal-scale')) return;
    el.classList.add(cls);
    if (stagger && i > 0) el.classList.add('d' + Math.min(i, 8));
  });
}

function setup() {
  /* ── Groups with stagger ── */
  // Competency tags
  animate(q('.flip-card'), 'reveal', true);
  // Past performance cards
  animate(q('.performance-card'), 'reveal', true);
  // NAICS / PSC code boxes
  //animate(q('#codes .code-box'), 'reveal-scale', true);
  // Differentiator items — slide from left
  animate(q('.differentiator-card'), 'reveal-left', true);
  // Brochure columns
  //animate(q('#brochure .brochure-layout > *'), 'reveal', true);
  // Logos
  //animate(q('.logo-bar > *'), 'reveal', true);
  // CTA contact items
  animate(q('.cta-contact-item'), 'reveal', true);
  // Inc 5000 / stat callout boxes
  animate(q('.gray-box'), 'reveal-scale', true);

  /* ── Everything else — broad sweep ── */
  // All sections except hero: grab every direct child of .container
  q('section:not(.hero) .container > *').forEach(function (el) {
    if (inSkip(el)) return;
    if (el.classList.contains('reveal') || el.classList.contains('reveal-left') || el.classList.contains('reveal-scale')) return;
    el.classList.add('reveal');
  });

  // Headings and labels that might be nested deeper
  q('section:not(.hero) h2, section:not(.hero) h3, section:not(.hero) .tag').forEach(function (el) {
    if (inSkip(el) || el.classList.contains('reveal')) return;
    el.classList.add('reveal');
  });

  // Individual paragraphs inside narrative / cta
  q('section:not(.hero) p, section:not(.hero) h2, section:not(.hero) .tag, section:not(.hero) .cta-primary').forEach(function (el) {
    if (el.classList.contains('reveal')) return;
    // If ancestor is already revealed, skip to avoid double animation
    if (el.closest('.reveal, .reveal-left, .reveal-scale')) return;
    el.classList.add('reveal');
  });

  // Images (team photo, doc preview)
  q('section:not(.hero) img, .brochure-shadow').forEach(function (el) {
    if (el.classList.contains('reveal')) return;
    el.classList.add('reveal-scale');
  });

  // Footer
  q('footer > *').forEach(function (el) { el.classList.add('reveal'); });

  // Peek-once on the first card to tease the flip
  var firstCard = document.querySelector('.flip-card');
  if (firstCard) {
    var firstCardInner = firstCard.querySelector('.flip-card-inner');

    if (firstCardInner) {
      var peekStartTimer = null;
      var peekResetTimer = null;

      var clearPeek = function () {
        if (peekStartTimer) clearTimeout(peekStartTimer);
        if (peekResetTimer) clearTimeout(peekResetTimer);
        firstCard.classList.remove('peek-once');
        firstCardInner.classList.remove('peek-tilt');
        firstCard.removeEventListener('mouseenter', clearPeek);
        firstCard.removeEventListener('focusin', clearPeek);
        firstCard.removeEventListener('touchstart', clearPeek);
      };

      var schedulePeek = function () {
        peekStartTimer = setTimeout(function () {
          firstCardInner.classList.add('peek-tilt');
          peekResetTimer = setTimeout(function () {
            firstCardInner.classList.remove('peek-tilt');
            schedulePeek();
          }, 420);
        }, 2200);
      };

      firstCard.classList.add('peek-once');
      schedulePeek();
      firstCard.addEventListener('mouseenter', clearPeek);
      firstCard.addEventListener('focusin', clearPeek);
      firstCard.addEventListener('touchstart', clearPeek);
    }
  }
}

function q(sel) { return Array.from(document.querySelectorAll(sel)); }

function observe() {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        // Jiggle flip-cards after their individual reveal finishes
        if (e.target.classList.contains('flip-card')) {
          var stagger = 0;
          for (var d = 1; d <= 8; d++) {
            if (e.target.classList.contains('d' + d)) { stagger = d * 70; break; }
          }
          (function (card) {
            setTimeout(function () {
              card.classList.add('jiggle');
              setTimeout(function () { card.classList.remove('jiggle'); }, 450);
            }, stagger + 580);
          })(e.target);
        }
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

  q('.reveal, .reveal-left, .reveal-scale').forEach(function (el) { io.observe(el); });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { setup(); observe(); });
} else {
  setup(); observe();
}